import React from 'react';
import type { ISteramMessage } from '../../../types';
import styles from './ChatMessage.module.scss';
import { CrownIcon, PersonIcon } from '../../../components/icons';
import { cleanAdminName } from '../../../utils/adminNameUtils';

interface ChatMessageProps {
    message: ISteramMessage;
    isOwnMessage: boolean;
    isFullscreen?: boolean;
    isOverlay?: boolean;
}

const formatTime = (date: Date) => {
    return date.toLocaleTimeString('ru-RU', {
        hour: '2-digit',
        minute: '2-digit'
    });
};

export const ChatMessage: React.FC<ChatMessageProps> = ({ message, isOwnMessage, isFullscreen = false, isOverlay = false }) => {
    const cleanUsername = cleanAdminName(message.username.replace(/^👑\s*/, ''));
    const isAdminMessage = cleanUsername.toLowerCase().includes('администратор') ||
        cleanUsername.toLowerCase().includes('admin') ||
        isOwnMessage;

    let messageClass: string;
    let headerClass: string;
    let bodyClass: string;

    if (isOverlay) {
        messageClass = `${styles.overlayMessage} ${isAdminMessage ? styles.adminMessage : ''}`;
        headerClass = styles.overlayHeader;
        bodyClass = styles.overlayBody;
    } else if (isFullscreen) {
        messageClass = `${styles.fullscreenMessage} ${isAdminMessage ? styles.adminMessage : ''}`;
        headerClass = styles.fullscreenHeader;
        bodyClass = styles.fullscreenBody;
    } else {
        messageClass = isOwnMessage ? styles.ownMessage : styles.message;
        headerClass = styles.header;
        bodyClass = styles.body;
    }

    const AvatarIcon = isAdminMessage ? CrownIcon : PersonIcon;

    return (
        <div className={messageClass}>
            <div className={styles.avatar}>
                <AvatarIcon />
            </div>
            <div style={{ flex: 1 }}>
                <div className={headerClass}>
                    <strong>{cleanUsername}</strong>
                    <span>{formatTime(new Date(message.created_at))}</span>
                </div>
                <div className={bodyClass}>
                    {message.message}
                </div>
            </div>
        </div>
    );
};